import { SVGProps } from 'react';

export const HeaderLabel = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="6"
      height="6"
      viewBox="0 0 6 6"
      fill="none"
      {...props}
    >
      <path
        d="M0 3.00014C0 2.60014 0.0733334 2.2268 0.22 1.88014C0.366667 1.53347 0.566667 1.23347 0.82 0.980137C1.08667 0.71347 1.39333 0.506804 1.74 0.360137C2.08667 0.213471 2.46 0.140137 2.86 0.140137C3.26 0.140137 3.63333 0.213471 3.98 0.360137C4.32667 0.506804 4.62667 0.71347 4.88 0.980137C5.14667 1.23347 5.35333 1.53347 5.5 1.88014C5.66 2.2268 5.74 2.60014 5.74 3.00014C5.74 3.40014 5.66 3.77347 5.5 4.12014C5.35333 4.4668 5.14667 4.77347 4.88 5.04014C4.62667 5.29347 4.32667 5.49347 3.98 5.64014C3.63333 5.7868 3.26 5.86014 2.86 5.86014C2.46 5.86014 2.08667 5.7868 1.74 5.64014C1.39333 5.49347 1.08667 5.29347 0.82 5.04014C0.566667 4.77347 0.366667 4.4668 0.22 4.12014C0.0733334 3.77347 0 3.40014 0 3.00014Z"
        fill="#0D3F5E"
      />
    </svg>
  );
};
